/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventdetectorEventEvent
 */
export interface EventdetectorEventEvent {
    /**
     * 
     * @type {string}
     * @memberof EventdetectorEventEvent
     */
    datasourcetype?: string;
    /**
     * 
     * @type {string}
     * @memberof EventdetectorEventEvent
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EventdetectorEventEvent
     */
    severity?: EventdetectorEventEventSeverityEnum;
}


/**
 * @export
 */
export const EventdetectorEventEventSeverityEnum = {
    Note: 'note',
    Warning: 'warning',
    Alert: 'alert'
} as const;
export type EventdetectorEventEventSeverityEnum = typeof EventdetectorEventEventSeverityEnum[keyof typeof EventdetectorEventEventSeverityEnum];


/**
 * Check if a given object implements the EventdetectorEventEvent interface.
 */
export function instanceOfEventdetectorEventEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventdetectorEventEventFromJSON(json: any): EventdetectorEventEvent {
    return EventdetectorEventEventFromJSONTyped(json, false);
}

export function EventdetectorEventEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventdetectorEventEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'datasourcetype': !exists(json, 'datasourcetype') ? undefined : json['datasourcetype'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'severity': !exists(json, 'severity') ? undefined : json['severity'],
    };
}

export function EventdetectorEventEventToJSON(value?: EventdetectorEventEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'datasourcetype': value.datasourcetype,
        'id': value.id,
        'severity': value.severity,
    };
}

